import { useContext } from 'react';
import { CbGuideCard } from 'ui/components/CbGuideCard';
import { NavigationButton } from './NavigationButton';
import { ArcadeLogo } from 'ui/assets/ArcadeLogo';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { GuideContext } from '../GuideContainer';
import styles from './NavigationContainer.module.css';
import { Progress } from '@chakra-ui/react';
export const NavigationContainer = () => {
  const {
    answerQuestion,
    canGoNext,
    canGoPrev,
    cardIndex,
    cards,
    guide,
    nextPage,
    prevPage,
    shouldShowNext,
    shouldShowPrev,
    startOver,
    guideLoading,
    cardsLoading
  } = useContext(GuideContext);
  if (guide === undefined || cards === undefined || cards.length === 0 || cardsLoading || guideLoading) {
    return null;
  }
  return <div className={styles.container} data-sentry-component="NavigationContainer" data-sentry-source-file="NavigationContainer.tsx">
      <div className={styles.titleContainer}>
        <span className={styles.title}>{guide?.title}</span>
      </div>
      <div className={styles.navigationContainer}>
        <div className={styles.cardsContainer} style={{
        transform: `translateX(-${cardIndex * 20}px)`
      }}>
          {cards.map((card, index) => {
          let visualIndex = index - cardIndex;
          return <CbGuideCard key={card.id} card={card} isActive={cardIndex === index} visualIndex={visualIndex} onAnswerQuestion={answerQuestion} />;
        })}
        </div>
      </div>
      <NavigationButton direction="prev" shouldShow={shouldShowPrev} onClickAction={prevPage} isDisabled={!canGoPrev} aria-label="Previous" aria-hidden={!canGoPrev} data-sentry-element="NavigationButton" data-sentry-source-file="NavigationContainer.tsx" />
      <NavigationButton direction="next" shouldShow={shouldShowNext} onClickAction={nextPage} isDisabled={!canGoNext} aria-label="Next" data-sentry-element="NavigationButton" data-sentry-source-file="NavigationContainer.tsx" />
      <a href="/" className={styles.logoContainer}>
        <ArcadeLogo width="120" color="white" data-sentry-element="ArcadeLogo" data-sentry-source-file="NavigationContainer.tsx" />
      </a>
      <div className={styles.footer}>
        {shouldShowPrev && <div className={styles.restartContainer} onClick={startOver}>
            <ICON_BY_NAME.restart />
            <p>Restart</p>
          </div>}
        <div className={styles.progressContainer}>
          <Progress className={styles.progress} size="xs" value={cardIndex + 0.25} max={cards.length - 0.75} colorScheme="cloud" borderRadius="5px" background="rgba(255, 255, 255, 0.2)" data-sentry-element="Progress" data-sentry-source-file="NavigationContainer.tsx" />
        </div>
      </div>
    </div>;
};